import { Modal, ModalBody, ModalHeader, CardBody, CardTitle, Spinner } from 'reactstrap'
import { IconLinkOff, IconX } from '@tabler/icons-react'
//@ts-ignore
import { Button, Input } from 'dsm-react-lib'
import { toast } from 'react-toastify'
import _endpoints from '../../../../_endpoints'
import { useParams } from 'react-router-dom'
import { useTeamService } from '../services/teamService'

interface RemoveAppModalProps {
  isOpen: boolean
  toggle: () => void
  app?: any
}

const RemoveAppModal: React.FC<RemoveAppModalProps> = ({ isOpen, toggle, app }) => {
  const { teamId } = useParams<{ teamId: string }>()
  const { isGettingApps, isRemovingApp, removeApplication } = useTeamService()

  const onRemoveApp = async () => {
    if (!teamId) return

    try {
      const response = await removeApplication(teamId, app.applicationId)
      if (response?.status && response.status >= 400) {
        toast.error('Failed to remove app. Please try again.')
      }
      toast.success('App removed successfully')
    } catch (error) {
      toast.error('Failed to remove app. Please try again.')
    }
    toggle()
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader
        className="flex items-center justify-between border-0 !bg-[var(--color-danger)]"
        toggle={toggle}
        close={
          <IconX
            size={24}
            onClick={toggle}
            className="text-white transition-colors duration-300 ease-in-out hover:text-white cursor-pointer"
            data-testid="close-button"
          />
        }>
        <div className="flex items-center">
          <IconLinkOff className="me-[6px]" color="white" size={18} />
          <span className="text-white">Remove App</span>
        </div>
      </ModalHeader>
      <ModalBody className="flex-grow-1 theme-surface">
        <div className="border-0">
          <CardBody className="px-0 py-1">
            <CardTitle tag="h4" className="mb-1">
              <b>Are you sure you want to remove this app?</b>
            </CardTitle>
            <span className="my-2 font-normal theme-text-subheading">
              The app will only be removed from your team workspace and won&apos;t be deleted. Team
              members will no longer have access to this app through this team.
            </span>
          </CardBody>
        </div>
        <div className={`flex justify-end gap-1 my-1 chat-primary`}>
          <Button
            label="Cancel"
            variant="outline"
            color="neutral"
            className="dsm-btn-neutral"
            onClick={toggle}
          />
          <Button
            label={isRemovingApp || isGettingApps ? 'Removing...' : 'Remove App'}
            color="danger"
            icon={
              isRemovingApp || isGettingApps ? <Spinner size="sm" /> : <IconLinkOff size={18} />
            }
            disabled={isRemovingApp || isGettingApps}
            onClick={onRemoveApp}
          />
        </div>
      </ModalBody>
    </Modal>
  )
}

export default RemoveAppModal
